<div class="sdps-row">

  <div class="section-header col sdps-p-vertical_x-small" [ngClass]="headerTxt === 'List Of Authorized Agents' ? 'agent-title': ''">
    <div class="sdps-pull-left">
      <div class="">
        <span class="sdps-display-inline-block vertical-align-middle sdps-font-weight-bold" [innerHTML]="headerTxt"></span>
      </div>
    </div>
    <ul class="sdps-pull-right header-section-list grid-header-icon no-margin">
      <li class="sdps-m-right_x-small display-refresh sdps-display-inline-block cursor">
        <a class="sdps-button--text-small" [innerHTML]="(lastUpdatedTime && lastUpdatedTime !== 'undefined' && lastUpdatedTime !== '') ? (lastUpdatedTxt ? lastUpdatedTxt + '&nbsp;' : '') + lastUpdatedTime : (lastUpdatedTxt || '')"></a>
      </li>
      <li class="sdps-m-right_x-small display-refresh sdps-display-inline-block cursor" *ngIf="showRefresh">
        <button type="button" class="sdps-button--text-small icons"
           (click)="refreshSection()"
           aria-label="Refresh section">
          <em class="sdps-font-weight-bold sdps-text-small sch-refresh" aria-hidden="true"></em>
        </button>
      </li>
    </ul>
  </div>
</div>
